import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { jwtDecode } from 'jwt-decode';

const ProtectedRoute = ({ children }) => {
  const navigate = useNavigate();
  const [tokenValid, setTokenValid] = useState(true);
  const token = localStorage.getItem('token');

  useEffect(() => {
    if (!token) {
      setTokenValid(false);
      navigate("/", { replace: true });
    } else {
      try {
        const decodedToken = jwtDecode(token);
        const currentTime = Date.now() / 1000;
        if (decodedToken.exp < currentTime) {
          setTokenValid(false);
          localStorage.removeItem("token");
          navigate("/", { replace: true });
        }
      } catch (error) {
        setTokenValid(false);
        localStorage.removeItem("token");
        navigate("/", { replace: true });
      }
    }
  }, [token, navigate]);

  if (!tokenValid) {
    return null;
  }

  return children;
};

export default ProtectedRoute;
